const reasonsData = {
  normal: {
    '0-1': [
      "领导，我感觉身体有点不舒服，想请假去医院看一下，望批准。",
      "领导，家里有点急事要处理，需要请假，处理完会立刻回来，谢谢领导。",
      "领导，我预约了牙医，需要请假去看牙，不好意思，望批准。",
      "领导，昨天没休息好，今天精神状态不佳，想请假调整一下。",
      "领导，我要去相关部门办理一些个人证件，需要请假，望批准。",
      "领导，有个重要的快递文件需要本人签收，但配送时间不确定，需要请假处理。",
      "领导，家里有维修人员上门，需要在家等待，谢谢。",
      "领导，我有点轻微感冒，为了不影响同事，申请居家休息。",
      "领导，我要去银行办理个人业务，需要请假，望批准。",
      "领导，我需要参加一个重要的家庭活动，希望能请假。",
      "领导，有个朋友从外地过来，我需要去接一下，望批准请假。",
      "领导，昨天运动时不小心拉伤了，需要休息一天。",
      "领导，家里的宠物突然生病了，得带它去看医生，希望能准假。",
      "领导，我报名了一个重要的线上课程，需要请假参加。",
      "领导，我最近在搬家，需要请假处理一些后续事宜。",
      "领导，我的驾照需要年检了，得去一趟车管所，望批准。",
      "领导，我需要去社区参加一个活动，希望能请假。",
      "领导，我遇到一些个人突发状况，需要紧急处理一下，望准假。",
      "领导，我需要陪同家人去医院复查，希望能请假。",
      "领导，我最近皮肤有些过敏，想去医院看一下，望准假。",
      "领导，孩子学校临时有事，需要我去一趟，望批准。",
      "领导，家里的水电出了点问题，约了师傅上门维修，需要请假。",
      "领导，我需要去参加一个亲戚的订婚仪式，希望能请假。",
      "领导，我的租房合同到期了，需要请假一天找新房子。",
      "领导，家里的燃气需要进行安全检查，必须有人在家。",
      "领导，我需要去办理一张新的银行卡，旧的丢失了。",
      "领导，我预约了车辆保养，需要请假一天。",
      "领导，我需要去公证处办理一份重要的文件公证。",
      "领导，孩子幼儿园要举办亲子活动，希望能参加。",
      "领导，我需要去出入境管理局办理护照更新。",
      "领导，家里停水了，物业通知今天维修，需要在家等候。",
      "领导，我需要去参加一个社区组织的志愿者活动。",
      "领导，我的身份证快到期了，需要请假去派出所办理新的。",
      "领导，我需要去处理一下个人档案的事情，望批准。",
      "领导，我约了驾校教练练车，为科目二做准备。",
      "领导，家里老人从老家过来，我需要去机场接一下。",
      "领导，我需要去参加一个朋友的乔迁之喜。",
      "领导，我的信用卡出现了一些问题，需要去银行柜台处理。",
      "领导，我需要去税务局办理一些个人税务事宜。",
      "领导，我报名了一个周末的课程，周五需要提前过去准备一下。",
      "领导，我需要去参加一个重要的面试，希望能有机会提升自己。",
      "领导，我的宠物走丢了，我得请假去找找它，非常着急。",
      "领导，我的手机突然坏了，需要去维修，担心错过重要信息，望批准。",
      "领导，家里突然停电了，需要在家等电力公司上门检修。",
      "领导，我需要去医院做一个常规体检，望批准。",
      "领导，家里老人身体不适，需要我陪同去医院。",
      "领导，我的银行卡被吞了，需要去银行处理。",
      "领导，我需要去派出所补办身份证，望批准。",
      "领导，家里有重要快递需要本人签收，时间不确定。",
      "领导，我需要去社区做核酸检测，排队时间较长，望批准。",
      "领导，我的房东临时通知要上门检查房屋，需要在家等候。",
      "领导，我需要去参加一个亲戚的生日聚会，望批准。",
      "领导，我的宠物需要打疫苗，必须本人带去。",
      "领导，我需要去银行开具一份重要证明材料。",
      "领导，我的家门锁坏了，师傅只能今天来修。",
      "领导，我需要去医院复查上次的检查结果。",
      "领导，我的家人今天搬家，需要我帮忙。",
      "领导，我需要去参加一个重要的考试，时间与工作冲突。",
      "领导，我的房屋漏水了，物业安排今天维修。",
      "领导，我需要去医院做牙齿治疗，预约在今天。",
      "领导，我的家人需要我陪同去办理证件。",
      "领导，我需要去银行办理工资卡相关业务。",
      "领导，我的家里有小孩生病，需要请假照顾。",
      "领导，我需要去医院做疫苗接种。",
      "领导，我的家人今天出院，需要我去接。",
      "领导，我需要去参加一个重要的面试，提升自己。",
      "领导，我的房东要来收房租，需要在家等候。",
      "领导，我需要去医院做视力检查。",
      "领导，我的家人需要我陪同去体检。",
      "领导，我需要去银行补办银行卡。",
      "领导，我的家里有重要文件需要本人签收。",
      "领导，我需要去医院做皮肤过敏检查。",
      "领导，我的家人需要我陪同去做手术前准备。",
      "领导，我需要去银行办理贷款手续。",
      "领导，我的家里有水管爆裂，需要紧急处理。",
      "领导，我需要去医院做B超检查。",
      "领导，我的家人需要我陪同去做健康咨询。",
      "领导，我需要去银行办理信用卡业务。",
      "领导，我的家里有燃气公司上门安检，需要在家等候。",
      "领导，我需要去医院做肠胃检查。",
      "领导，我的家人需要我陪同去做康复治疗。",
      "领导，我需要去银行办理存款证明。"
    ],
    '1-3': [
      "老大，我想请假处理一下私事，工作已交接好，请放心。",
      "由于一些个人事务需要处理，希望能请假一天，我会提前安排好手头的工作。",
      "家人需要陪同看病，情况比较紧急，希望能请假处理。",
      "孩子学校有活动需要家长参加，希望能准假，感谢领导。",
      "最近项目压力较大，身体略感不适，希望请假一天进行休整，感谢理解。",
      "领导，我需要去参加一个朋友的婚礼，他是我的挚友，希望能请假一天。",
      "领导，我报名了驾照科目三考试，需要请假一天参加考试。",
      "领导，最近眼睛不太舒服，想请假去医院做个详细检查。",
      "领导，家里老人身体不适，需要我带去医院看看，望批准。",
      "领导，孩子在学校有点状况，老师让我过去一趟，希望能准假。",
      "领导，我需要去办理居住证续签，这个必须本人到场，望批准。",
      "领导，最近在考虑买房，约了中介去看几个地方，希望能请假半天。",
      "领导，我的个人电脑坏了，需要拿去修理，里面有很多重要资料。",
      "领导，社区组织义务献血活动，我想去参加，为社会做点贡献。",
      "领导，我需要去公证处办理一份文件，这个有时效性，望批准。",
      "领导，有个远房亲戚来访，需要我去车站接一下，请假半天。",
      "领导，最近睡眠质量很差，想请假一天在家好好休息，调整一下生物钟。",
      "领导，我需要去处理一下交通违章，必须本人到场，望批准。",
      "领导，我预约了体检，想对自己的健康状况有个全面的了解。",
      "领导，家里宽带网络出了问题，约了维修师傅上门，需要在家等着。",
      "领导，我需要去银行办理房贷相关手续，时间比较紧急。",
      "领导，我的家人需要我陪同去做健康体检。",
      "领导，我需要去医院做牙齿矫正复查。",
      "领导，我的房屋需要做防水维修，师傅只能今天来。",
      "领导，我需要去参加一个重要的资格证考试。",
      "领导，我的家人需要我陪同去做康复训练。",
      "领导，我需要去银行处理信用卡还款问题。",
      "领导，我的家里有重要文件需要本人签收。",
      "领导，我需要去医院做皮肤过敏检查。",
      "领导，我的家人需要我陪同去做手术前准备。",
      "领导，我需要去银行办理贷款手续。",
      "领导，我的家里有水管爆裂，需要紧急处理。",
      "领导，我需要去医院做B超检查。",
      "领导，我的家人需要我陪同去做健康咨询。",
      "领导，我需要去银行办理信用卡业务。",
      "领导，我的家里有燃气公司上门安检，需要在家等候。",
      "领导，我需要去医院做肠胃检查。",
      "领导，我的家人需要我陪同去做康复治疗。",
      "领导，我需要去银行办理存款证明。",
      "领导，我的家里有重要快递需要本人签收，时间不确定。",
      "领导，我需要去社区做核酸检测，排队时间较长，望批准。",
      "领导，我的房东临时通知要上门检查房屋，需要在家等候。",
      "领导，我需要去参加一个亲戚的生日聚会，望批准。",
      "领导，我的宠物需要打疫苗，必须本人带去。",
      "领导，我需要去银行开具一份重要证明材料。",
      "领导，我的家门锁坏了，师傅只能今天来修。",
      "领导，我需要去医院复查上次的检查结果。",
      "领导，我的家人今天搬家，需要我帮忙。",
      "领导，我需要去参加一个重要的考试，时间与工作冲突。",
      "领导，我的房屋漏水了，物业安排今天维修。",
      "领导，我需要去医院做牙齿治疗，预约在今天。",
      "领导，我的家人需要我陪同去办理证件。",
      "领导，我需要去银行办理工资卡相关业务。",
      "领导，我的家里有小孩生病，需要请假照顾。",
      "领导，我需要去医院做疫苗接种。",
      "领导，我的家人今天出院，需要我去接。",
      "领导，我需要去参加一个重要的面试，提升自己。",
      "领导，我的房东要来收房租，需要在家等候。",
      "领导，我需要去医院做视力检查。",
      "领导，我的家人需要我陪同去体检。",
      "领导，我需要去银行补办银行卡。",
      "领导，我的家里有重要文件需要本人签收。",
      "领导，我需要去医院做皮肤过敏检查。",
      "领导，我的家人需要我陪同去做手术前准备。",
      "领导，我需要去银行办理贷款手续。",
      "领导，我的家里有水管爆裂，需要紧急处理。",
      "领导，我需要去医院做B超检查。",
      "领导，我的家人需要我陪同去做健康咨询。",
      "领导，我需要去银行办理信用卡业务。",
      "领导，我的家里有燃气公司上门安检，需要在家等候。",
      "领导，我需要去医院做肠胃检查。",
      "领导，我的家人需要我陪同去做康复治疗。",
      "领导，我需要去银行办理存款证明。",
      "领导，我需要去参加一个行业交流会，提升专业能力。",
      "领导，我的朋友结婚需要我帮忙，望批准请假。",
      "领导，我需要去参加一个重要的家庭聚会。",
      "领导，我的家人需要我陪同去做心理咨询。",
      "领导，我需要去医院做健康复查，确保身体状况良好。",
      "领导，我的家里有重要的维修工程需要我协调。",
      "领导，我需要去参加一个职业技能提升课程。",
      "领导，我的家人需要我陪同去做康复训练。",
      "领导，我需要去银行处理个人理财业务。"]
  },
  funny: {
    '0-1年': [
      "领导，我新买的植物今天发芽了，我得请假回家见证这个历史性时刻。",
      "领导，我需要请假一天，因为我的乐观精神用完了，得回家充值。",
      "领导，我的键盘上字母Q和P键私奔了，我得请假去找它们。",
      "领导，我昨天看了一场恐怖电影，今天我的影子不敢一个人待着，我得陪它。",
      "领导，我家的WiFi改了密码，但它没告诉我，我得请假回家跟它谈谈。",
      "领导，我需要请假，因为我感觉我的办公桌在排斥我，它今天早上把我推开了。",
      "领导，我发现我的左右脚今天想走不同的路，我得请假一天让它们冷静一下。",
      "领导，我的闹钟今天早上没叫醒我，我觉得它需要心理辅导，我得陪它去。",
      "领导，我需要请假去参加一个'如何假装在工作'的研讨会，我觉得对我有帮助。",
      "领导，我家的金鱼淹死了，我得请假给它办个海葬。",
      "领导，我感觉我的工位风水不好，今天不宜上班，请假一天改改运。",
      "领导，我需要请假，因为我昨天数星星数到一半睡着了，今天得接着数完。",
      "领导，我的手机和充电器吵架了，我得请假在家调解一下。",
      "领导，我预约了给我的盆栽理发，Tony老师很难约的。",
      "领导，我需要请假一天，因为我发现我还活在昨天。",
      "领导，我家的猫把我当成了猫抓板，我需要请假处理一下'工伤'。",
      "领导，我需要请假，因为我的想象力离家出走了，我得去找它回来。",
      "领导，我今天早上出门穿了两只不一样的袜子，强迫症犯了，必须回家换。",
      "领导，我需要请假，因为我突然对'为什么水是湿的'这个问题产生了浓厚的兴趣，必须研究一下。",
      "领导，我感觉我的身体里住了两个人，一个想上班，一个不想，今天不想上班的那个赢了。"]
  },
  high_eq: {
    'default': [
      "领导，为了能以更饱满的热情和更高效的状态投入到接下来的工作中，我希望能请假短暂休整一下，补充能量。相信这短暂的离开能为团队带来更长远的价值。",
      "领导，我遇到一个需要集中精力处理的个人事务，为了不因此分散工作注意力，影响团队进度，我希望能请假处理妥当。我会确保工作无缝交接，请您放心。",
      "领导，我计划利用假期进行一次深入的行业学习和自我提升，希望能够借此机会为团队储备新的知识和技能，更好地应对未来的挑战。",
      "领导，家庭是我坚实的后盾，最近家里有些事情需要我协调。一个稳定的家庭环境能让我更无后顾之忧地投入工作，因此希望能请假处理好家事，感谢您的理解与支持。",
      "领导，最近感觉身体发出了一些需要关注的信号，我想请假去做个全面的健康检查，确保能以最佳的身体状态为公司持续做贡献。",
      "领导，为了更好地平衡工作与生活，我计划请假处理一些积压的个人事务。一个清爽的后方能让我更专注地投入到工作中。",
      "领导，我希望能请假参加一个关于沟通/时间管理等相关技能的短期课程，这不仅能提升我个人能力，也能更好地应用于团队协作中。",
      "领导，我的一位良师益友遇到了困难，我希望能请假去支持他。我相信，维系重要的人脉关系，长远来看也是一笔宝贵的财富。",
      "领导，最近在项目冲刺中精神高度紧张，希望能短暂休整，进行心理上的复盘和调整，以便后续能更有创造力地解决问题。",
      "领导，我需要处理一项有时效性的家庭财务规划，这对我个人至关重要。处理妥当后，我能更安心地投入工作。",
      "领导，我报名了一个志愿者活动，希望能为社会贡献一份力量。我相信这种经历也能拓宽我的视野，为工作带来新的启发。",
      "领导，我需要陪同家人进行一次重要的医疗咨询。家人的健康是我努力工作的最大动力，恳请您理解。",
      "领导，我最近在复盘前一阶段的工作，发现了一些可以改进的地方。希望能请假一天，静心思考，整理成方案向您汇报。",
      "领导，我的一位重要客户/合作伙伴从外地过来，我想利用私人时间尽一下地主之谊，这可能对我们未来的合作关系有积极影响。",
      "领导，孩子学校有一个重要的亲子活动，我希望能参与其中，见证孩子的成长。和谐的家庭氛围是高效工作的基础。",
      "领导，我计划进行一次短途旅行，给自己换个环境，激发一些新的灵感。我相信这对我们正在进行的创意性工作会有帮助。",
      "领导，我需要处理一些证件续办的事宜，以确保个人信息的有效性，避免未来可能出现的麻烦影响到工作。",
      "领导，我的一位前辈/导师邀请我参加一个私人聚会，这是一个难得的学习和交流机会，希望能得到您的批准。",
      "领导，最近持续高强度工作，感觉身体有些透支。我想请假进行积极性休息，比如做一些轻度运动，以更好地恢复精力。",
      "领导，我需要处理一些房屋相关的事务，一个安稳的居住环境是专心工作的保障。",
      "领导，我希望能请假一天，整理和规划一下我未来的职业发展路径，并思考如何能更好地与公司的发展目标相结合。",
      "领导，我的一位朋友正在经历一个艰难时期，我希望能去陪伴和安慰他。我相信，一个有温度的团队，成员之间也应该互相关怀。",
      "领导，我需要去处理一项法律相关的个人事务，以保障我的合法权益。处理好这些，我才能更踏实地工作。",
      "领导，我计划利用假期时间阅读几本与我们行业相关的书籍，进行知识更新。我相信持续学习是保持竞争力的关键。",
      "领导，最近在思考如何优化我们的团队协作流程，有了一些初步想法，希望能请假一天，把它系统地整理出来。",
      "领导，我需要带孩子去接种疫苗，这是作为父母的责任。我会提前安排好工作，确保无缝衔接。",
      "领导，我希望能请假参加一个冥想或正念的课程，学习如何更好地管理压力和保持专注，这对提升工作效率很有帮助。",
      "领导，我的一位亲人即将进行一个重要的手术，我希望能去陪护。家人的支持对我至关重要，感谢您的体谅。",
      "领导，我发现自己的知识体系有些老化，希望能请假参加一个线上研讨会，接触一些前沿的理念和技术。",
      "领导，我需要处理一项跨城市的个人事务，往返需要一些时间。我会通过电话和网络保持联系，确保紧急事务能得到及时处理。",
      "领导，我希望能请假一天，彻底打扫和整理一下我的居住空间。我相信，一个整洁有序的环境能反映并促进清晰的思维。",
      "领导，我的一位远方亲戚难得来访，我希望能尽一下孝心/情谊，陪伴他们。这对我来说意义重大。",
      "领导，我最近在工作上遇到了一些瓶颈，希望能请假跳出环境，从不同的角度审视问题，寻找突破口。",
      "领导，我承诺的个人成长计划（例如健身、学习）遇到一个关键节点，需要请假处理。我相信信守承诺的品质在工作中同样重要。",
      "领导，我希望能请假一天，去参加一个关于时间管理的培训，提升自我效率，回来后会与团队分享收获。",
      "领导，近期工作强度较大，我想请假一天进行身心调整，以更好地投入后续工作。",
      "领导，我需要请假陪伴家人处理一项重要事务，家庭的支持能让我更专注于工作。",
      "领导，我希望能请假参加一个公益志愿活动，提升社会责任感，也为团队树立榜样。",
      "领导，我计划利用假期进行一次深度阅读和学习，提升专业能力，回来后会与同事交流心得。",
      "领导，我需要请假一天，整理和优化个人工作流程，提升后续工作效率。",
      "领导，我希望能请假参加一个心理健康讲座，学习压力管理技巧，更好地应对工作挑战。",
      "领导，我需要请假陪伴家人参加一次重要的家庭聚会，家庭和睦有助于我更好地投入工作。",
      "领导，我希望能请假一天，反思和总结近期工作，制定更科学的目标和计划。",
      "领导，我计划利用假期进行一次运动锻炼，增强体质，以更好地应对高强度工作。",
      "领导，我需要请假参加一个行业交流会，拓展视野，为团队带来新思路。",
      "领导，我希望能请假一天，陪伴孩子参加学校活动，家庭幸福是我努力工作的动力。",
      "领导，我计划利用假期进行一次自我提升课程学习，提升综合素质。",
      "领导，我需要请假一天，陪伴父母体检，家人的健康是我安心工作的基础。",
      "领导，我希望能请假参加一个关于沟通技巧的培训，提升团队协作能力。",
      "领导，我计划利用假期进行一次短途旅行，调整心态，激发工作灵感。",
      "领导，我需要请假一天，处理个人财务规划，确保后顾无忧地投入工作。",
      "领导，我希望能请假参加一个关于创新思维的研讨会，回来后会与团队分享。",
      "领导，我计划利用假期进行一次健康检查，关注身体状况，保障工作持续性。",
      "领导，我需要请假一天，陪伴家人完成一项重要的家庭仪式。",
      "领导，我希望能请假参加一个关于领导力提升的课程，助力团队发展。",
      "领导，我计划利用假期进行一次深度整理和反思，优化个人成长路径。",
      "领导，我需要请假一天，陪伴朋友度过人生重要时刻，珍惜人际关系。",
      "领导，我希望能请假参加一个关于情绪管理的课程，提升自我调节能力。",
      "领导，我计划利用假期进行一次技能认证考试，提升专业竞争力。",
      "领导，我需要请假一天，陪伴家人完成一项重要的法律手续。",
      "领导，我希望能请假参加一个关于团队建设的活动，增强团队凝聚力。",
      "领导，我计划利用假期进行一次自我反思，制定更科学的职业规划。",
      "领导，我需要请假一天，陪伴亲人完成一项重要的医疗检查。",
      "领导，我希望能请假参加一个关于高效沟通的研讨会，提升团队协作。",
      "领导，我计划利用假期进行一次公益活动，回馈社会，提升个人价值感。",
      "领导，我需要请假一天，陪伴家人完成一项重要的搬迁事宜。",
      "领导，我希望能请假参加一个关于创新管理的课程，助力团队创新。",
      "领导，我计划利用假期进行一次深度学习，提升行业前沿知识。",
      "领导，我需要请假一天，陪伴朋友完成一项重要的生活事件。",
      "领导，我希望能请假参加一个关于压力管理的讲座，提升抗压能力。",
      "领导，我计划利用假期进行一次自我成长训练营，提升综合素质。",
      "领导，我需要请假一天，陪伴家人完成一项重要的庆典活动。",
      "领导，我希望能请假参加一个关于职业规划的课程，明确发展方向。",
      "领导，我计划利用假期进行一次深度整理，优化生活与工作的平衡。",
      "领导，我需要请假一天，陪伴亲人完成一项重要的康复治疗。",
      "领导，我希望能请假参加一个关于自我激励的培训，提升工作动力。",
      "领导，我计划利用假期进行一次行业调研，带回新思路。",
      "领导，我需要请假一天，陪伴家人完成一项重要的教育活动。",
      "领导，我希望能请假参加一个关于高效学习的课程，提升学习能力。",
      "领导，我计划利用假期进行一次自我管理训练，提升自律能力。",
      "领导，我需要请假一天，陪伴朋友完成一项重要的志愿服务。",
      "领导，我希望能请假参加一个关于幸福感提升的讲座，优化生活质量。",
      "领导，我计划利用假期进行一次深度阅读，拓展知识面。",
      "领导，我需要请假一天，陪伴家人完成一项重要的文化活动。",
      "领导，我希望能请假参加一个关于团队协作的实战训练，提升团队效率。",
      "领导，我计划利用假期进行一次自我探索，明确人生目标。",
      "领导，我需要请假一天，陪伴亲人完成一项重要的心理咨询。",
      "领导，我希望能请假参加一个关于创新创业的论坛，获取行业新知。",
      "领导，我计划利用假期进行一次深度复盘，优化工作方法。",
      "领导，我需要请假一天，陪伴家人完成一项重要的社会活动。",
      "领导，我希望能请假参加一个关于自我成长的沙龙，提升综合素养。",
      "领导，我计划利用假期进行一次健康管理课程学习，关注身心健康。",
      "领导，我需要请假一天，陪伴朋友完成一项重要的公益活动。",
      "领导，我想请假去参加一个高强度英语写作训练营，提升国际表达能力。",
      "领导，我要去参加一个极限体能拉练，锻炼意志力，为团队做表率。",
      "领导，我报名了一个高阶数据建模实战营，想请假专注学习。",
      "领导，我要去参加一个行业顶级创新论坛，争取为公司带回新思路。",
      "领导，我想请假去参加一个极限编程马拉松，提升代码能力，回来后会带动团队进步。",
      "领导，我报名了一个高强度产品创新训练营，想请假全情投入。",
      "领导，我要去参加一个行业顶级运营大赛，争取为公司赢得荣誉。",
      "领导，我想请假去参加一个极限时间管理挑战，提升自我效率。",
      "领导，我要去参加一个高阶演讲实战营，提升表达能力，回来后会做团队分享。",
      "领导，我报名了一个行业顶级安全攻防演练，想请假全情投入。",
      "领导，我要去参加一个极限创新思维训练，回来后会带动团队头脑风暴。",
      "领导，我想请假去参加一个高强度跨界学习营，提升多元能力。",
      "领导，我要去参加一个行业顶级产品路演，争取为公司争取更多资源。",
      "领导，我报名了一个极限自律挑战营，想请假专注自我提升。",
      "领导，我要去参加一个高阶领导力训练营，回来后会带动团队成长。",
      "领导，我想请假去参加一个行业顶级技术沙龙，学习最新趋势。",
      "领导，我要去参加一个极限专注力训练，提升工作效率。",
      "领导，我报名了一个高强度创新创业大赛，想请假全情投入。",
      "领导，我要去参加一个行业顶级运营实战营，回来后会优化团队流程。",
      "领导，我想请假去参加一个极限挑战营，锻炼抗压能力。",
      "领导，我要去参加一个高阶战略规划训练，提升团队整体战斗力。",
      "领导，我报名了一个行业顶级用户体验大赛，想请假争取荣誉。",
      "领导，我要去参加一个极限学习马拉松，提升知识广度。",
      "领导，我想请假去参加一个高强度团队协作训练营，回来后会提升团队凝聚力。",
      "领导，我要去参加一个行业顶级品牌创新大赛，争取为公司带来新突破。",
      "领导，我报名了一个极限自我管理挑战，想请假专注成长。",
      "领导，我要去参加一个高阶谈判实战营，提升商务能力。",
      "领导，我想请假去参加一个行业顶级数据黑客松，学习最新数据技术。",
      "领导，我要去参加一个极限抗压训练，提升心理素质。",
      "领导，我报名了一个高强度创新思维训练营，想请假全情参与。",
      "领导，我要去参加一个行业顶级市场营销大赛，争取为公司赢得市场。",
      "领导，我想请假去参加一个极限效率挑战，提升时间利用率。",
      "领导，我要去参加一个高阶跨文化交流训练营，提升国际视野。",
      "领导，我报名了一个行业顶级供应链创新大赛，想请假争取突破。",
      "领导，我要去参加一个极限自律力训练，提升自我管理能力。",
      "领导，我想请假去参加一个高强度领导力挑战营，回来后会带动团队成长。",
      "领导，我要去参加一个行业顶级创新论坛，学习最新行业动态。",
      "领导，我报名了一个极限学习挑战，想请假专注提升。",
      "领导，我要去参加一个高阶项目实战营，提升项目管理能力。",
      "领导，我想请假去参加一个行业顶级技术创新大赛，争取为公司赢得荣誉。",
      "领导，我要去参加一个极限团队协作挑战，提升团队默契。",
      "领导，我报名了一个高强度自我突破训练营，想请假全情投入。",
      "领导，我要去参加一个行业顶级创新创业峰会，回来后会带动团队创新。",
      "领导，我想请假去参加一个高强度英语演讲比赛，提升国际表达力。",
      "领导，我要去参加一个极限体能挑战赛，锻炼意志力。",
      "领导，我报名了一个高阶数据分析大赛，想请假专注参赛。",
      "领导，我要去参加一个行业顶级创新大赛，争取为公司带回新思路。",
      "领导，我想请假去参加一个极限编程挑战赛，提升代码能力。",
      "领导，我报名了一个高强度产品创新大赛，想请假全情投入。",
      "领导，我要去参加一个行业顶级运营创新大赛，争取为公司赢得荣誉。",
      "领导，我想请假去参加一个极限时间管理大赛，提升自我效率。",
      "领导，我要去参加一个高阶演讲大赛，提升表达能力。",
      "领导，我报名了一个行业顶级安全攻防大赛，想请假全情投入。",
      "领导，我要去参加一个极限创新思维大赛，回来后会带动团队头脑风暴。",
      "领导，我想请假去参加一个高强度跨界创新大赛，提升多元能力。",
      "领导，我要去参加一个行业顶级产品创新大赛，争取为公司争取更多资源。",
      "领导，我报名了一个极限自律创新大赛，想请假专注自我提升。",
      "领导，我要去参加一个高阶领导力大赛，回来后会带动团队成长。",
      "领导，我想请假去参加一个行业顶级技术创新论坛，学习最新趋势。",
      "领导，我要去参加一个极限专注力大赛，提升工作效率。",
      "领导，我报名了一个高强度创新创业创新大赛，想请假全情投入。",
      "领导，我要去参加一个行业顶级运营创新实战营，回来后会优化团队流程。",
      "领导，我想请假去参加一个极限挑战大赛，锻炼抗压能力。",
      "领导，我要去参加一个高阶战略规划大赛，提升团队整体战斗力。"]
  },
  mysterious: {
    'default': [
      "要去见一个能决定我下半生的人。",
      "处理一些'历史遗留问题'。",
      "一个重要的约定，不能失约。",
      "去一个能让灵魂得到净化的地方。",
      "赴一个与'未来'的约会。",
      "有些事情，现在必须去做。",
      "有些答案，只有今天才能找到。",
      "时间到了，我必须离开一会儿。",
      "有些门，只在特定的时刻打开。",
      "我需要去完成一项未竟的使命。",
      "有个人在等我，不能让他久等。",
      "今天是一个特殊的日子，必须亲自见证。",
      "有些秘密，只能在今天揭晓。",
      "我需要去一个只有我知道的地方。",
      "有些事情，解释了就不神秘了。",
      "我收到了一条只有我能解读的信息。",
      "有些缘分，错过就不再有。",
      "我需要去追寻一个梦里的指引。",
      "有些约定，只有我记得。",
      "今天的我，必须完成一件只有我能做的事。",
      "有些谜题，只有亲自去才能解开。",
      "我需要去见证一场只属于我的奇迹。",
      "有些路，只有今天能走。",
      "我需要去收集一些只属于今天的线索。",
      "有些人，只能在今天遇见。",
      "我需要去完成一场命运的安排。",
      "有些故事，只有今天能续写。",
      "我需要去守护一个无法言说的承诺。",
      "有些信号，只有我能接收。",
      "我需要去参加一场无声的仪式。",
      "有些感应，只有今天才会出现。",
      "我需要去寻找一把只出现一次的钥匙。",
      "有些时刻，错过就永远错过了。",
      "我需要去完成一场与自己的对话。",
      "有些答案，只有沉默才懂。",
      "我需要去见证一段只属于我的时空。",
      "有些旅程，只有我能启程。",
      "有些梦，只有今天才能追寻。",
      "我需要去见证一场只属于我的奇迹。",
      "有些门，只有在特定时刻才会打开。",
      "我收到了一条神秘的邀请，必须亲自赴约。",
      "有些谜题，只有我能解开。",
      "今天的我，必须完成一件无人知晓的任务。",
      "有些路，只有我能走。",
      "我需要去收集一些只属于今天的线索。",
      "有些人，只能在今天遇见。",
      "我需要去完成一场命运的安排。",
      "有些故事，只有今天能续写。",
      "我需要去守护一个无法言说的承诺。",
      "有些信号，只有我能接收。",
      "我需要去参加一场无声的仪式。",
      "有些感应，只有今天才会出现。",
      "我需要去寻找一把只出现一次的钥匙。",
      "有些时刻，错过就永远错过了。",
      "我需要去完成一场与自己的对话。",
      "有些答案，只有沉默才懂。",
      "我需要去见证一段只属于我的时空。",
      "有些旅程，只有我能启程。",
      "我收到了一封没有署名的信，必须亲自查明。",
      "有些约定，只有我记得。",
      "我需要去追寻一个梦里的指引。",
      "有些缘分，错过就不再有。",
      "我需要去完成一场命运的试炼。",
      "有些谜团，只有亲自经历才能明白。",
      "我需要去见证一场只属于我的奇迹。",
      "有些门，只有今天会为我敞开。",
      "我收到了一条来自未来的信息。",
      "有些路，只有今天能走。",
      "我需要去收集一些遗失的记忆。",
      "有些人，只能在今天相见。",
      "我需要去完成一场注定的邂逅。",
      "有些故事，只有今天能续写。",
      "我需要去守护一个被遗忘的承诺。",
      "有些信号，只有我能感应。"]
  },
  hardcore: {
    'default': [
      "领导，我想请假去参加一个行业峰会，虽然是自费，但我觉得能带回一些对公司有价值的信息。",
      "领导，我发现了一个能极大提升我们工作效率的工具，我想请假一天，把它彻底研究明白然后引入团队。",
      "领导，我报名了一个高阶技能培训班，课程时间与工作冲突，但我保证会利用下班时间把工作补上，绝不耽误项目。",
      "领导，我想请假去拜访一位业界大牛，向他请教一些我们项目目前遇到的难题，希望能获得一些启发。",
      "领导，我打算利用假期时间，把我们部门的知识库重新梳理和完善一遍，方便新同事快速上手。",
      "领导，我想请假一天，去参加一个顶级算法竞赛，回来后会把经验分享给团队。",
      "领导，我报名了一个凌晨5点的线上编程马拉松，想请假全程参与，提升极限。",
      "领导，我要去参加一个行业黑客松，争取为公司赢得荣誉。",
      "领导，我想请假去参加一个AI前沿技术闭门研讨会，回来后会做内部分享。",
      "领导，我要去参加一个极限体能挑战，锻炼意志力，为团队树立榜样。",
      "领导，我报名了一个高强度英语口语训练营，想请假全情投入，提升国际沟通力。",
      "领导，我要去参加一个产品创新大赛，争取为公司带回新思路。",
      "领导，我想请假去参加一个行业领袖圆桌，学习最前沿的管理理念。",
      "领导，我要去参加一个极限编程挑战，提升代码能力，回来后会带动团队进步。",
      "领导，我报名了一个高阶数据分析训练营，想请假专心学习。",
      "领导，我要去参加一个行业顶级黑客大会，争取为公司建立更多技术联系。",
      "领导，我想请假去参加一个极限耐力跑步比赛，锻炼身体和意志。",
      "领导，我要去参加一个创新创业训练营，回来后会推动团队创新。",
      "领导，我报名了一个高强度项目管理实战营，想请假全程参与。",
      "领导，我要去参加一个行业顶级设计大赛，争取为公司赢得奖项。",
      "领导，我想请假去参加一个极限时间管理挑战，提升自我效率。",
      "领导，我要去参加一个高阶演讲训练营，提升表达能力，回来后会做团队分享。",
      "领导，我报名了一个行业顶级安全攻防演练，想请假全情投入。",
      "领导，我要去参加一个极限创新思维训练，回来后会带动团队头脑风暴。",
      "领导，我想请假去参加一个高强度跨界学习营，提升多元能力。",
      "领导，我要去参加一个行业顶级产品路演，争取为公司争取更多资源。",
      "领导，我报名了一个极限自律挑战营，想请假专注自我提升。",
      "领导，我要去参加一个高阶领导力训练营，回来后会带动团队成长。",
      "领导，我想请假去参加一个行业顶级技术沙龙，学习最新趋势。",
      "领导，我要去参加一个极限专注力训练，提升工作效率。",
      "领导，我报名了一个高强度创新创业大赛，想请假全情投入。",
      "领导，我要去参加一个行业顶级运营实战营，回来后会优化团队流程。",
      "领导，我想请假去参加一个极限挑战营，锻炼抗压能力。",
      "领导，我要去参加一个高阶战略规划训练，提升团队整体战斗力。",
      "领导，我报名了一个行业顶级用户体验大赛，想请假争取荣誉。",
      "领导，我要去参加一个极限学习马拉松，提升知识广度。",
      "领导，我想请假去参加一个高强度团队协作训练营，回来后会提升团队凝聚力。",
      "领导，我要去参加一个行业顶级品牌创新大赛，争取为公司带来新突破。",
      "领导，我报名了一个极限自我管理挑战，想请假专注成长。",
      "领导，我要去参加一个高阶谈判实战营，提升商务能力。",
      "领导，我想请假去参加一个行业顶级数据黑客松，学习最新数据技术。",
      "领导，我要去参加一个极限抗压训练，提升心理素质。",
      "领导，我报名了一个高强度创新思维训练营，想请假全情参与。",
      "领导，我要去参加一个行业顶级市场营销大赛，争取为公司赢得市场。",
      "领导，我想请假去参加一个极限效率挑战，提升时间利用率。",
      "领导，我要去参加一个高阶跨文化交流训练营，提升国际视野。",
      "领导，我报名了一个行业顶级供应链创新大赛，想请假争取突破。",
      "领导，我要去参加一个极限自律力训练，提升自我管理能力。",
      "领导，我想请假去参加一个高强度领导力挑战营，回来后会带动团队成长。",
      "领导，我要去参加一个行业顶级创新论坛，学习最新行业动态。",
      "领导，我报名了一个极限学习挑战，想请假专注提升。",
      "领导，我要去参加一个高阶项目实战营，提升项目管理能力。",
      "领导，我想请假去参加一个行业顶级技术创新大赛，争取为公司赢得荣誉。",
      "领导，我要去参加一个极限团队协作挑战，提升团队默契。",
      "领导，我报名了一个高强度自我突破训练营，想请假全情投入。",
      "领导，我要去参加一个行业顶级创新创业峰会，回来后会带动团队创新。",
      "领导，我想请假去参加一个高强度英语演讲比赛，提升国际表达力。",
      "领导，我要去参加一个极限体能挑战赛，锻炼意志力。",
      "领导，我报名了一个高阶数据分析大赛，想请假专注参赛。",
      "领导，我要去参加一个行业顶级创新大赛，争取为公司带回新思路。",
      "领导，我想请假去参加一个极限编程挑战赛，提升代码能力。",
      "领导，我报名了一个高强度产品创新大赛，想请假全情投入。",
      "领导，我要去参加一个行业顶级运营创新大赛，争取为公司赢得荣誉。",
      "领导，我想请假去参加一个极限时间管理大赛，提升自我效率。",
      "领导，我要去参加一个高阶演讲大赛，提升表达能力。",
      "领导，我报名了一个行业顶级安全攻防大赛，想请假全情投入。",
      "领导，我要去参加一个极限创新思维大赛，回来后会带动团队头脑风暴。",
      "领导，我想请假去参加一个高强度跨界创新大赛，提升多元能力。",
      "领导，我要去参加一个行业顶级产品创新大赛，争取为公司争取更多资源。",
      "领导，我报名了一个极限自律创新大赛，想请假专注自我提升。",
      "领导，我要去参加一个高阶领导力大赛，回来后会带动团队成长。",
      "领导，我想请假去参加一个行业顶级技术创新论坛，学习最新趋势。",
      "领导，我要去参加一个极限专注力大赛，提升工作效率。",
      "领导，我报名了一个高强度创新创业创新大赛，想请假全情投入。",
      "领导，我要去参加一个行业顶级运营创新实战营，回来后会优化团队流程。",
      "领导，我想请假去参加一个极限挑战大赛，锻炼抗压能力。",
      "领导，我要去参加一个高阶战略规划大赛，提升团队整体战斗力。"]
  }
};

const professions = ['程序员', '设计师', '销售', '教师', '运营', '产品经理'];
const leaveTypes = ['事假', '病假', '调休', '年假'];
const durations = ['半天', '一天', '三天', '一周'];

export const generateReason = (formData) => {
  const { experience, style } = formData;

  let reasonList = reasonsData[style]?.[experience];

  // If no specific list for the experience, try the 'default' for the style
  if (!reasonList) {
    reasonList = reasonsData[style]?.['default'];
  }

  // If the style is invalid or has no lists at all, fallback to a safe default
  if (!reasonList) {
    reasonList = reasonsData['normal']['1-3'];
  }

  const randomIndex = Math.floor(Math.random() * reasonList.length);
  return reasonList[randomIndex];
};

export const options = {
  professions,
  experiences: ['0-1年', '1-3年', '3-5年', '5年以上'],
  leaveTypes,
  durations,
  styles: [
    { value: 'normal', label: '正常理由' },
    { value: 'funny', label: '搞笑理由' },
    { value: 'high_eq', label: '高情商理由' },
    { value: 'mysterious', label: '猜不透理由' },
    { value: 'hardcore', label: '内卷风' },
  ]
};
